import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { featureNestedRoutes } from '../../app-routes';
import { FeatureSurfaceProvider } from '../feature-setup/FeatureSurfaceProvider';
import { EditAutomationTemplate } from '../feature-setup/edit-automation-template';
import { EditSegmentPage } from '../feature-setup/edit-segment';
import { ReputationNavigator } from './ReputationNavigator';

export const ReputationSetup: React.FC = () => {
  // Routes are relative to /dashboard/reputation/* where this component is rendered
  return (
    <FeatureSurfaceProvider feature="reputation">
      <div className="space-y-6">
        <Routes>
          <Route path={featureNestedRoutes.AUTOMATIONS_EDIT} element={<EditAutomationTemplate />} />
          <Route path={featureNestedRoutes.SEGMENTS_NEW} element={<EditSegmentPage />} />
          <Route path={featureNestedRoutes.SEGMENTS_EDIT} element={<EditSegmentPage />} />
          <Route path=":tab?" element={<ReputationNavigator />} />
        </Routes>
      </div>
    </FeatureSurfaceProvider>
  );
};
